import { render, staticRenderFns } from "./redpackage-record-export.vue?vue&type=template&id=6dbab514&scoped=true&"
import script from "./redpackage-record-export.vue?vue&type=script&lang=js&"
export * from "./redpackage-record-export.vue?vue&type=script&lang=js&"
import style0 from "./redpackage-record-export.vue?vue&type=style&index=0&id=6dbab514&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbab514",
  null
  
)

export default component.exports